import LongLat from "@mapmycustomers/shared/types/base/LongLat";
import AreaRegion from "@mapmycustomers/shared/types/territory/AreaRegion";

type LatLngLiteral = google.maps.LatLngLiteral;

const convertPathToLatLngLiteral = (path: LongLat[]): LatLngLiteral[] =>
  path.map(([lng, lat]) => ({ lat, lng }));
const convertPolygon = (polygon: LongLat[][]) => polygon.map(convertPathToLatLngLiteral);
const convertMultiPolygon = (multiPolygon: LongLat[][][]) => multiPolygon.map(convertPolygon);

const areaRegionGeometryGetter = (
  region: AreaRegion
): Exclude<google.maps.Data.FeatureOptions["geometry"], undefined> => {
  return region.geometry.type === "Polygon"
    ? new google.maps.Data.Polygon(convertPolygon(region.geometry.coordinates))
    : new google.maps.Data.MultiPolygon(convertMultiPolygon(region.geometry.coordinates));
};

export default areaRegionGeometryGetter;
